import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path d="M3.9 12C3.9 10.29 5.29 8.9 7 8.9H11V7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15.1H7C5.29 15.1 3.9 13.71 3.9 12ZM8 13H16V11H8V13ZM17 7H13V8.9H17C18.71 8.9 20.1 10.29 20.1 12C20.1 13.71 18.71 15.1 17 15.1H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3.46537 5.57941C4.34895 5.06399 5.47437 4.93994 6.50006 4.93994C6.8121 4.93994 7.06506 5.1929 7.06506 5.50494C7.06506 5.81698 6.8121 6.06994 6.50006 6.06994C5.52575 6.06994 4.65117 6.1959 4.03475 6.55548C3.47254 6.88343 3.06506 7.43887 3.06506 8.50494C3.06506 9.57101 3.47254 10.1265 4.03475 10.4544C4.65117 10.814 5.52575 10.9399 6.50006 10.9399C6.8121 10.9399 7.06506 11.1929 7.06506 11.5049C7.06506 11.817 6.8121 12.0699 6.50006 12.0699C5.47437 12.0699 4.34895 11.9459 3.46537 11.4305C2.52758 10.8834 1.93506 9.93887 1.93506 8.50494C1.93506 7.07101 2.52758 6.12645 3.46537 5.57941ZM12.5347 5.57941C11.6512 5.06399 10.5257 4.93994 9.50006 4.93994C9.18802 4.93994 8.93506 5.1929 8.93506 5.50494C8.93506 5.81698 9.18802 6.06994 9.50006 6.06994C10.4744 6.06994 11.3489 6.1959 11.9654 6.55548C12.5276 6.88343 12.9351 7.43887 12.9351 8.50494C12.9351 9.57101 12.5276 10.1265 11.9654 10.4544C11.3489 10.814 10.4744 10.9399 9.50006 10.9399C9.18802 10.9399 8.93506 11.1929 8.93506 11.5049C8.93506 11.817 9.18802 12.0699 9.50006 12.0699C10.5257 12.0699 11.6512 11.9459 12.5347 11.4305C13.4725 10.8834 14.0651 9.93887 14.0651 8.50494C14.0651 7.07101 13.4725 6.12645 12.5347 5.57941ZM5.50006 7.93994C5.18802 7.93994 4.93506 8.1929 4.93506 8.50494C4.93506 8.81698 5.18802 9.06994 5.50006 9.06994H10.5001C10.8121 9.06994 11.0651 8.81698 11.0651 8.50494C11.0651 8.1929 10.8121 7.93994 10.5001 7.93994H5.50006Z"
  />
);

export const LinkIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Link" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
